/* eslint-disable @stencil-community/required-jsdoc */
import { Component, Host, h, Prop } from '@stencil/core';

import type { ColorVariant } from '../../../types/colors.types';

@Component({
  tag: 'efb-loading-icon',
  styleUrl: 'loading-icon.scss',
  shadow: true,
})
export class EfbLoadingIcon {
  /**
   * Props
   */
  @Prop() variant?: ColorVariant = 'purple';

  /**
   * Render
   */

  render() {
    return (
      <Host>
        <div class={`loading-icon ${this.variant && `is-${this.variant}`}`}></div>
      </Host>
    );
  }
}
